import { axios, API } from './config';

export const customChargeTemplatesAPI = {
  getAll: async () => {
    const res = await axios.get(`${API}/custom-charge-templates`);
    return res.data;
  },
  create: async (data) => {
    const res = await axios.post(`${API}/custom-charge-templates`, data);
    return res.data;
  },
  update: async (id, data) => {
    const res = await axios.put(`${API}/custom-charge-templates/${id}`, data);
    return res.data;
  },
  delete: async (id) => {
    const res = await axios.delete(`${API}/custom-charge-templates/${id}`);
    return res.data;
  },
  seedDefaults: async () => {
    const res = await axios.post(`${API}/custom-charge-templates/seed-defaults`);
    return res.data;
  },
};
